import styled from 'styled-components';
import { media } from '../../../stylings';
import { Loader } from '../../Loader/Loader';

const S = {
  Wrapper: styled.div`
    align-items: center;
    display: flex;
    justify-content: center;
    margin-top: 32px;
    min-height: 100vh;

    @media ${media.greaterThan('lg')} {
      margin-top: 80px;
    }
  `,
};

export function CartLoader() {
  return (
    <S.Wrapper role="status">
      <Loader isDark />
    </S.Wrapper>
  );
}
